<template>
  <div>
    <CustomerTable v-show="activeKey===1" ref="list" :data-sources="dataSources" :storers="storers" :type="type" @add="add" @edit="edit"/>
    <CustomerDetail v-show="activeKey===2" ref="detail" :classifications="classifications" :data-sources="dataSources" :pickup-modes="pickupModes" :regions="regions" :storers="storers" :turnover-modes="turnoverModes" :type="type" @back="back"/>
  </div>
</template>

<script>
import CustomerTable from '@/views/basedata/customer_basedata/CustomerTable.vue'
import CustomerDetail from '@/views/basedata/customer_basedata/CustomerDetail.vue'
import { getDictionaries, getEnums, getOptions } from '@/utils/util'

export default {
  name: 'CustomerTemplate',
  components: { CustomerTable, CustomerDetail },
  data() {
    return {
      activeKey: 1,
      classifications: [],
      regions: [],
      dataSources: [],
      turnoverModes: [],
      pickupModes: [],
      storers: []
    }
  },
  created() {
    getDictionaries('CUSTOMER_CLASSIFICATION').then(result => {
      this.classifications = result
      return getDictionaries('REGION')
    }).then(result => {
      this.regions = result
      return getEnums('DataSource')
    }).then(result => {
      this.dataSources = result
      return getEnums('TurnoverMode')
    }).then(result => {
      this.turnoverModes = result
      return getDictionaries('PICKUP_MODE')
    }).then(result => {
      this.pickupModes = result
      return getOptions('storerFactory', { available: true })
    }).then(result => {
      this.storers = result
    })
  },
  props: {
    type: { default: null }
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.list.refresh()
    },
    add() {
      this.activeKey = 2
      this.$refs.detail.add()
    },
    edit(id, copy) {
      this.activeKey = 2
      this.$refs.detail.refresh(id, copy)
    }
  }
}
</script>